import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationRule } from '@/features/notification-rules/schemas/notification-rules.schema.ts';

export const useDeleteNotificationRuleMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ notificationRuleId }: Pick<NotificationRule, 'notificationRuleId'>) => {
      return toast.promise(client.delete(`/notifications/rules/${notificationRuleId}`), {
        loading: 'Deleting notification rule...',
        success: 'Successfully deleted the notification rule.',
        error: (_: unknown) =>
          `Uh oh, there was an error with deleting the notification rule.`,
      });
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', 'rules'] });
    },
  });
};
